import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Thead,
  Tr,
  Th,
  Flex,
  Skeleton,
  VStack,
  HStack,
  Text,
  Heading,
  IconButton,
} from "@chakra-ui/react";
import React from "react";
import { useDeleteShift } from "../../services/configurationService";
import { FiEdit, FiTrash2, FiClock } from "react-icons/fi";

const ShiftTable = ({ configurationData = [], handleEdit, config, refetchGetShift, getShiftIsLoading }) => {
  const { deleteShiftPayload } = useDeleteShift((res) => refetchGetShift());

  const handleDelete = (id) => {
    deleteShiftPayload(id);
  };

  if (getShiftIsLoading) {
    return (
      <Box p={6}>
        <TableContainer>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Shift Name</Th>
                <Th>Start Time</Th>
                <Th>End Time</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <Tr key={i}>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                  <Th><Skeleton height="20px" /></Th>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  if (!getShiftIsLoading && !configurationData?.length) {
    return (
      <Box p={8} textAlign="center">
        <VStack spacing={4}>
          <Box
            p={4}
            borderRadius="50%"
            bg="gray.100"
            color="gray.500"
            fontSize="2xl"
          >
            ⏰
          </Box>
          <VStack spacing={2}>
            <Text fontSize="lg" fontWeight="600" color="gray.700">
              No Shifts Found
            </Text>
            <Text color="gray.500" fontSize="sm">
              No shift records found. Add your first shift to get started.
            </Text>
          </VStack>
        </VStack>
      </Box>
    );
  }

  return (
    <Box>
      {/* Table Header */}
      <Flex 
        justifyContent="space-between" 
        alignItems="center" 
        p={6} 
        borderBottom="1px solid" 
        borderColor="gray.200"
        bg="white"
      >
        <VStack align="start" spacing={1}>
          <Heading size="md" color="gray.900" fontWeight="600">
            Shift Directory
          </Heading>
          <Text color="gray.600" fontSize="sm">
            {configurationData?.length || 0} shifts
          </Text>
        </VStack>
      </Flex>

      {/* Shift Table */}
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Shift Name</Th>
              <Th>Start Time</Th>
              <Th>End Time</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {configurationData?.map((item) => (
              <ShiftTableRow
                key={item?.id}
                id={item?.id}
                name={item?.name}
                from={item?.from_time}
                to={item?.to_time}
                onEdit={() => handleEdit(item)}
                onDelete={() => handleDelete(item?.id)}
              />
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

// Shift Table Row Component
const ShiftTableRow = ({ id, name, from, to, onEdit, onDelete }) => {
  const formatShiftTime = (timeString) => {
    if (!timeString) return "N/A";
    
    // Handle datetime format like "1900-01-01 09:45:00"
    let timePart = timeString;
    if (timeString.includes(' ')) {
      timePart = timeString.split(' ')[1]; // Extract time part after space
    }
    
    // Parse hours and minutes
    const [hours, minutes] = timePart.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <Tr _hover={{ bg: "gray.50" }}>
      <Th>{id}</Th>
      <Th>
        <HStack spacing={2}>
          <FiClock color="gray.500" />
          <Text>{name}</Text>
        </HStack>
      </Th>
      <Th>{formatShiftTime(from)}</Th>
      <Th>{formatShiftTime(to)}</Th>
      <Th>
        <HStack spacing={2} justify="center">
          <IconButton
            icon={<FiEdit />}
            variant="ghost"
            size="sm"
            aria-label="Edit shift"
            onClick={onEdit}
            color="green.500"
            _hover={{ bg: "green.50" }}
          />
          <IconButton
            icon={<FiTrash2 />}
            variant="ghost"
            size="sm"
            aria-label="Delete shift"
            onClick={onDelete}
            color="red.500"
            _hover={{ bg: "red.50" }}
          />
        </HStack>
      </Th>
    </Tr>
  );
};

export default ShiftTable;
  